import pizzaImg from '../assets/img/placeholder images/image (4).png';
import burgerImg from '../assets/img/placeholder images/image (1).png';
import dishImg from '../assets/img/placeholder images/image (2).png';
import coldDrinkImg from '../assets/img/placeholder images/image (3).png';
import coffeeCupImg from '../assets/img/placeholder images/image (5).png';

/**
 * Demo gallery photos shown when the store has no gallery images yet.
 * categoryKey is stable for filtering; labels/descriptions come from i18n.
 */
export const galleryPhotosPlaceholderMeta = [
    { id: 'placeholder-gallery-pizza', imgUrl: pizzaImg, categoryKey: 'food', descKey: 'pizza' },
    { id: 'placeholder-gallery-burger', imgUrl: burgerImg, categoryKey: 'food', descKey: 'burger' },
    { id: 'placeholder-gallery-dish', imgUrl: dishImg, categoryKey: 'dining', descKey: 'dish' },
    { id: 'placeholder-gallery-drink', imgUrl: coldDrinkImg, categoryKey: 'drinks', descKey: 'drink' },
    { id: 'placeholder-gallery-coffee', imgUrl: coffeeCupImg, categoryKey: 'drinks', descKey: 'coffee' },
];

export function getGalleryPhotosPlaceholder(t) {
    return galleryPhotosPlaceholderMeta.map((item) => ({
        id: item.id,
        imgUrl: item.imgUrl,
        category: item.categoryKey,
        description: t(`gallery.placeholders.${item.descKey}`),
    }));
}
